<template>
  <span></span>
</template>

<script>
  import i18n from '@/i18n';
  import Helper from '@/helper/Helper';
  import Api from '@/api/Api';

  export default {
    name: 'KeyboardCodeHandler',
    props: {},
    mounted: function () {
      const modul = this;
      window.addEventListener('keypress', function (e) {
        if (!window.pressedKeys) {
          window.pressedKeys = [];
        }
        if (window.pressedKeys.length > 16) {
          window.pressedKeys.shift();
        }
        window.pressedKeys.push({key: e.key, timeStamp: e.timeStamp});
        clearTimeout(window.pressedKeysTimeout);
        window.pressedKeysTimeout = setTimeout(modul.elemzo, 200);
      });
    },
    methods: {
      elemzo() {
        const modul = this;
        let arrKeys = [];
        let lastKey = {};
        let isEnd = false;
        Array.prototype.forEach.call(window.pressedKeys.reverse(), function (element) {
          if (!isEnd) {
            if (typeof lastKey.timeStamp === "undefined" || Math.abs(element.timeStamp - lastKey.timeStamp) < 80) {
              arrKeys.push(element);
            } else {
              isEnd = true;
            }
            lastKey = element;
          }
        });
        modul.kiiro(arrKeys);
      },
      kiiro(arrKeysParam) {
        const modul = this;
        if (arrKeysParam.length > 10) {
          let val = "";
          arrKeysParam.reverse().forEach(function (element) {
            if (element.key.length === 1) {
              val += element.key;
            }
          });
          let valChanged = val.replace(/ö/g, '0');
          Api.getDataBySid({code: valChanged}).then(function (res) {
            if (res && res.buyer) {
              modul.$eventBus.$emit('globalReadBuyerSid', res.buyer);
            }
            if (res && res.element) {
              modul.$eventBus.$emit('globalReadElement', res.element);
            }
            if (res && res.businesspartner) {
              modul.$eventBus.$emit('globalReadBusinessPartnerSid', res.businesspartner);
            }
          });
        }
      },
    },
    components: {},
  };
</script>

<style>
</style>

